import {
    PAGE_TRAFFIC_WITH_CONVERSION_SUCCESS,
    PAGE_TRAFFIC_WITH_CONVERSION_LOADING,
    PAGE_TRAFFIC_WITH_CONVERSION_FOR_GRAPH_SUCCESS,
    PAGE_TRAFFIC_WITH_CONVERSION_FOR_GRAPH_LOADING

} from '../actions/PageTrafficWithConversionAction';

const initialState = {
    pageTrafficWithConversionData: null,
    isLoading: true,
    pageTrafficWithConversionForGraphData: null,
    isGraphLoading: true,
};

const PageTrafficWithConversionReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case PAGE_TRAFFIC_WITH_CONVERSION_SUCCESS:
            return { ...state, pageTrafficWithConversionData: action.data, isLoading: false };

        case PAGE_TRAFFIC_WITH_CONVERSION_LOADING:
            return { ...state, isLoading: action.isLoading };

        case PAGE_TRAFFIC_WITH_CONVERSION_FOR_GRAPH_SUCCESS:
            return { ...state, pageTrafficWithConversionForGraphData: action.data, isGraphLoading: false };

        case PAGE_TRAFFIC_WITH_CONVERSION_FOR_GRAPH_LOADING:
            return { ...state, isGraphLoading: action.isGraphLoading };

        default:
            return state;
    }
};

export default PageTrafficWithConversionReducer;
